import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function SiteFeasibilityBoard() {
  return (
    <PageTemplate
      title="Sites: Feasibility Board"
      tooltipText="Review site feasibility status and regulatory document readiness across study sites."
      type="site-startup"
      selectionIdentifierColumn="site"
      constants={{
        wikiLink: "/wiki/guides/exploration-site-feasibility-board",
        idLink: undefined,
      }}
    />
  );
}
